export enum EnvType {
  Production = "production",
  ProductionK8 = "production-k8",
  Development = "devel",
  Local = "local"
}
interface IEnvironment {
  API_URL: string,

  MIN_SECURITY_LEVEL?: number;
  MIN_STORAGE_COUNT?: number;
  MAX_STORAGE_COUNT?: number;

  type?: EnvType;
}

let env: IEnvironment = {
  API_URL: import.meta.env.VITE_API_URL,
  type: import.meta.env.VITE_ENV_TYPE as EnvType
};

export const CONFIG = {
  // these will always be environment specific
  apiURL: env.API_URL,
  type: env.type,

  // these will rarely be different thus have common defaults
  minSecurityLevel: env.MIN_SECURITY_LEVEL || 2,
  minStoragesCount: env.MIN_STORAGE_COUNT || 2,
  maxStoragesCount: env.MAX_STORAGE_COUNT || 6,
  instructionPageUrl: "https://kb.myota.io"
};
